// src/sections/Insegne.jsx
import React, { useState, useEffect } from "react";
import CarButton from "../components/CarButton";

const Insegne = ({ contenuti }) => {
  // trasformo l'oggetto in array
  const contenutiArray = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  // gestione mobile
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {contenutiArray.map((content, index) => {
        const {
          titolo_1: titolo1,
          titolo_2: titolo2,
          sottotitolo_it: sottotitolo,
          descrizione_it: descrizione,
          link_it: link,
          call_to_action_it: callToAction,
          immagine_url: immagineBg,
          immagini_aggiuntive: immaginiAggiuntive,
        } = content;

        return (
          <div
            key={index}
            className="container-fluid d-flex flex-column justify-content-start position-relative"
            style={{
              padding: "64px 16px",
              gap: "16px",
              backgroundImage: immagineBg
                ? `url(${immagineBg})`
                : undefined,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row w-100">
                {/* Colonna sinistra */}
                <div className="col-12 col-md-6 d-flex flex-column align-items-start">
                  {/* Sottotitolo */}
                  {sottotitolo && <p className="mini-title">{sottotitolo}</p>}

                  {/* Titolo principale split su due span */}
                  <div className="title-section">
                    <h2
                      className={`black-text ${
                        isMobile
                          ? "d-block d-lg-none title-section-mobile"
                          : "d-none d-lg-block title-section"
                      }`}
                    >
                      {titolo1}
                    </h2>
                    <h2
                      className={`green-text ${
                        isMobile
                          ? "d-block d-lg-none title-section-mobile"
                          : "d-none d-lg-block title-section"
                      }`}
                    >
                      {titolo2}
                    </h2>
                  </div>
                </div>

                {/* Colonna destra */}
                <div className="col-12 col-md-6 d-flex flex-column align-items-start gap-3 mt-3 mt-md-0">
                  {/* Descrizione HTML */}
                  {descrizione && (
                    <p
                      className="custom-text"
                      dangerouslySetInnerHTML={{ __html: descrizione }}
                    />
                  )}

                  {/* Pulsante */}
                  {callToAction && (
                    <CarButton
                      text={callToAction}
                      to={link}
                      customClass="btn btn-three"
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Galleria di immagini aggiuntive */}
            {Array.isArray(immaginiAggiuntive) && immaginiAggiuntive.length > 0 && (
              <div className="container py-3 d-flex flex-md-row justify-content-between">
                <div className="col-12 col-md-8 d-flex flex-column flex-md-row justify-content-between align-items-center w-100">
                  {immaginiAggiuntive.map((img, idx) => (
                    <div
                      key={idx}
                      className=" d-flex justify-content-center align-items-center mb-2 mb-md-0"
                    >
                      <img
                        src={img.immagine_path}
                        alt={`Image ${idx + 1}`}
                        className="img-fluid"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default Insegne;
